import { Skeleton } from "@/components/ui/skeleton";

export function PaymentListItemSkeleton() {
  return (
    <div
      role="status"
      aria-label="Loading payment"
      className="relative w-full bg-white rounded-2xl border border-border p-5 shadow-xs"
    >
      <div className="flex items-start justify-between gap-3 mb-4">
        <div className="flex items-start gap-3 min-w-0">
          <Skeleton className="h-10 w-10 rounded-full shrink-0" />
          <Skeleton className="h-5 w-32 mt-2" />
        </div>
        <Skeleton className="h-6 w-20 rounded-full" />
      </div>
      <div className="flex justify-between items-end gap-3">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-7 w-24" />
      </div>
    </div>
  );
}
